module.exports = __webpack_public_path__ + "static/img/338_phase_function_Paper_PointsHejduk_Prediction.fed56f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/338_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 2Oof
// module chunks = 0